export default "__VITE_ASSET__e7c52c95__"